import React, { useState } from 'react';
import withRouter from '../../../../../services/util/withRouter';

import classes from './LCDComponent.module.css';

type Props = {
	lcdWidth: number,
	lcdHeight: number,
	lines: string[],
	backColor: String,
	foreColor: String
};

type States = {};

class LCDComponent extends React.Component<Props, States> {
	constructor(props) {
		super(props);
	}

	
	/**
	 * This function prepares the blocks for a single line of the LCD
	 * The blocks are fixed width, so if the line is shorter than the width,
	 * empty blocks are added
	 * 
	 * The colors could come from props or state in the future,
	 * but it was requested to be static for now
	 * @param {*} line 
	 * @returns 
	 */
	getBlocksForLine(lineIndex: number) {
		let inInvertedFace = false;
		const blocks = [];
		const line = this.props.lines[lineIndex] || '';
		const invertedMap = this.props.invertedMap[lineIndex] || [];

		for (let i = 0; i < this.props.lcdWidth; i++) {
			// Control characters for inverting the face
/*
			if (line.charAt(i) == '\x02') {
				inInvertedFace = true;
				continue;
			} 
			if (line.charAt(i) == '\x01') {
				inInvertedFace = false;
				continue;
			}			
				*/
			//line.replace('\x1F', '\x0A')

			blocks.push(
				<div key={`lcd-char-${i}`} className={`${classes.lcdblock} lcd_font`}
					style={invertedMap[i]
						? { backgroundColor: '#171717', color: 'rgb(200, 200, 200)', border: '1px solid #d0d0d0' } 
						: { color: '#171717', border: '1px solid #d0d0d0' }}> 
					{i < line.length ? line.charAt(i) : ''}
				</div>
			);
		}
		
		return blocks;
	}

	render() {
		// Colors are not used currently, but could be in the future
		const {lines, backColor, foreColor, invertedMap } = this.props;
		//console.log('Rendering LCD with lines: ', lines);
		const lcdLines = lines.map((line, idx) => (			
			<div key={`lcd-line-${idx}`} className={classes.lcdline}>
				{this.getBlocksForLine(idx)}		
			</div>
		));
		return (
			<>
				<div
                    className={classes.lcdbackground}
					style={{
						backgroundColor: '#c8c8c8',						
					}}
				>
					{lcdLines}
				</div>
			</>
		);
	}
}

export default withRouter(LCDComponent);
